import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=0f6809b3&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=0f6809b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6809b3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VehicleSelectorButton: require('/app/components/VehicleSelectorButton.vue').default,CommercialOperationMenuEntry: require('/app/components/CommercialOperationMenuEntry.vue').default,HeaderCart: require('/app/components/HeaderCart.vue').default})
